import styled from 'styled-components';

export const TuitionWrapper = styled.div``;

export const TuitionContent = styled.div`
  padding: 12px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TuitionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > img {
    height: 100px;
    width: 100%;
    object-fit: contain;
  }

  > p {
    text-align: center;

    > span {
      text-transform: capitalize;
    }
  }
`;

export const TuitionDate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div {
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 1px solid #a8cbe2;
    border-radius: 4px;
    background-color: #f7fafb;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;

      > div {
        width: 20px;
      }

      > span {
        font-size: 14px;
      }
    }

    > p {
      font-size: 12px;
      font-weight: 700;
      color: #1a055d;
    }
  }
`;

export const TuitionModality = styled.p`
  font-size: 14px;
  color: #1a055d;

  > b {
    text-transform: capitalize;
  }
`;

export const TuitionAlert = styled.div<{ debt?: boolean }>`
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-radius: 4px;
  background-color: ${(prop) => (prop.debt ? '#22aa00' : '#fc4a61')};

  > span {
    font-weight: 900;
    font-size: 12px;
    color: #ffffff;
  }
`;

export const TuitionDebt = styled.div<{ debt?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > p {
    font-weight: 700;
    font-size: 12px;
    color: #4f6168;
    display: ${(prop) => (prop.debt ? 'none' : 'block')};
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;

      > span {
        font-size: 14px;
        color: #161d1f;
      }
    }

    > span {
      font-weight: 700;
      font-size: 14px;
      color: #161d1f;
      display: ${(prop) => (prop.debt ? 'none' : 'block')};
    }
  }
`;

export const TuitionDivider = styled.hr`
  height: 1px;
  width: 100%;
  display: block;
  border: none;
  background-color: #d5e5f0;
`;

export const TuitionInit = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;

  > span {
    font-size: 12px;
    color: #4f6168;
  }
`;

export const TuitionLink = styled.a`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  border-radius: 4px;
  color: #ffffff;
  background-color: #5b36f2;

  @media (min-width: 640px) {
    width: max-content;
  }
`;

export const TuitionFooter = styled.div`
  padding: 12px 32px;
  border-top: 1px solid #d5e5f0;
`;

export const TuitionFooterWhatsapp = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > div:nth-of-type(1) {
    border-radius: 100%;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e2dffd;
  }

  > div:nth-of-type(2) {
    font-size: 12px;

    > span {
      display: block;
    }
  }
`;
